import { render, staticRenderFns } from "./BillReceivablePartialCommonPrint.vue?vue&type=template&id=5b587099&scoped=true"
import script from "./BillReceivablePartialCommonPrint.vue?vue&type=script&lang=js"
export * from "./BillReceivablePartialCommonPrint.vue?vue&type=script&lang=js"
import style0 from "./BillReceivablePartialCommonPrint.vue?vue&type=style&index=0&id=5b587099&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b587099",
  null
  
)

export default component.exports